export default "__VITE_ASSET__de2406c9__"